import { FETCH_EVENT, FETCH_EVENT_SUCCESS, FETCH_EVENT_FAILURE } from '../actions';

const initialState = {
  event: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_EVENT:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        event: action.data
      };
    case FETCH_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        event: {}
      };
    default:
      return state;
  }
}